
import ExternalModal from './external-modal'
export default {
  components: {
    ExternalModal
  },
  props: {
    href: {type: String, required: true}
  },
  methods: {
    openModal(){
      this.$refs.modal.open()
    }
  }
}
